import React from 'react';

import ProductPrice from './product-price'
import { withError } from '../../shared/components/error-boundary';

/**
 * Place holder componet for product cards that includes product price.
 * This is to support the SLP feature of filtering out OOS and NO IR skus
 */
class ProductCardPlaceHolder extends React.PureComponent {

	render() {
		let {
            product,
            className=''
		} = this.props;

		return (<div className={'product-card placeholder' + className} data-sku={product.sku} style={{height: "700px"}} >
                {product.prdClass !== "USER_DEFINED"  && <ProductPrice product={product} />}
			</div>
		);
	}
}


export default withError(ProductCardPlaceHolder);
